import React from 'react';
import classes from './playersOfMonth.module.css';
import PlayersCard from '../../containers/playersCard/playersCard';
import Title from '../../containers/title/title';

const PlayersOfMonth = (props) => {
    return (
        <div className={classes.Container}>
            <Title title={props.playersOfMonthTitle}/>
            <div className={classes.PlayersContainer}>{props.playersOfMonth?.map((player,i) => (
                <PlayersCard key={i} player={player}/>
            ))}</div>
        </div>
    )
}

export default PlayersOfMonth;